var __jsx = React.createElement;
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
var PREFIX = "Engineering Village";
function BaseLayout(_ref) {
  var title = _ref.title,
    isPublic = _ref.isPublic,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: "".concat(PREFIX).concat(title ? " - ".concat(title) : ""),
    isPublic: isPublic
  }), /*#__PURE__*/React.createElement("main", {
    id: "maincontent"
  }, children), /*#__PURE__*/React.createElement(Footer, {
    isPublic: isPublic
  }));
}
BaseLayout.defaultProps = {
  title: "",
  isPublic: false
};
export default BaseLayout;